import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { createElement } from "react";
import { publicLoader } from "./loader";
import { apiRunner } from "./api-runner-browser";
import { grabMatchParams } from "./find-path"; // Renders page

var PageRenderer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PageRenderer, _React$Component);

  function PageRenderer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageRenderer.prototype;

  _proto.render = function render() {
    var props = Object.assign({}, this.props, {
      params: Object.assign({}, grabMatchParams(this.props.location.pathname), this.props.pageResources.json.pageContext.__params),
      pathContext: this.props.pageContext
    });

    var _apiRunner = apiRunner("replaceComponentRenderer", {
      props: this.props,
      loader: publicLoader
    }),
        replacementElement = _apiRunner[0];

    var pageElement = replacementElement || /*#__PURE__*/createElement(this.props.pageResources.component, Object.assign({}, props, {
      key: this.props.path || this.props.pageResources.page.path
    }));
    var wrappedPage = apiRunner("wrapPageElement", {
      element: pageElement,
      props: props
    }, pageElement, function (_ref) {
      var result = _ref.result;
      return {
        element: result,
        props: props
      };
    }).pop();
    return wrappedPage;
  };

  return PageRenderer;
}(React.Component);

export default PageRenderer;